var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessWaitlistFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#EF6C00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#EF6C00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10400_103363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 9.33333C16.22 9.33333 16.1067 9.34667 16 9.36667V7C16 6.08 15.2533 5.33333 14.3333 5.33333C14.2067 5.33333 14.0867 5.34667 13.9733 5.37333C13.8333 4.59333 13.1533 4 12.3333 4C11.6267 4 11.0267 4.44 10.78 5.06C10.64 5.02 10.4867 5 10.3333 5C9.41332 5 8.66666 5.74667 8.66666 6.66667V7.03333C8.55999 7.01333 8.44666 7 8.33332 7C7.41332 7 6.66666 7.74667 6.66666 8.66667V14.3333C6.66666 17.46 9.20666 20 12.3333 20C15.46 20 18 17.46 18 14.3333V11C18 10.08 17.2533 9.33333 16.3333 9.33333ZM16.6667 14.3333C16.6667 16.7267 14.7267 18.6667 12.3333 18.6667C9.93999 18.6667 7.99999 16.7267 7.99999 14.3333V8.66667C7.99999 8.48 8.14666 8.33333 8.33332 8.33333C8.51999 8.33333 8.66666 8.48 8.66666 8.66667V12H9.99999V6.66667C9.99999 6.48 10.1467 6.33333 10.3333 6.33333C10.52 6.33333 10.6667 6.48 10.6667 6.66667V11.3333H12V5.66667C12 5.48 12.1467 5.33333 12.3333 5.33333C12.52 5.33333 12.6667 5.48 12.6667 5.66667V11.3333H14V7C14 6.81333 14.1467 6.66667 14.3333 6.66667C14.52 6.66667 14.6667 6.81333 14.6667 7V12.9467C13.4867 13.46 12.6667 14.6333 12.6667 16H14C14 14.8933 14.8933 14 16 14V11C16 10.8133 16.1467 10.6667 16.3333 10.6667C16.52 10.6667 16.6667 10.8133 16.6667 11V14.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10400_103363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessWaitlistFilled);
export default __webpack_public_path__ + "static/media/AccessWaitlistFilled.def28437e21d857baa40571da3db9808.svg";
export { ForwardRef as ReactComponent };